import { gql } from '@apollo/client'

export const ProductListingCountQuery = gql`
    query productListingCountQuery {
        productListingCount @client
    }
`
export const GetTableViewSettings = gql`
    query getTableViewSettingOfUser {
        getTableViewSettingOfUser {
            selectedColumns {
                columnName
                columnWidth
                order
                isColumnPinned
                columnOrder
            }
            isTableGroupingEnabled
            tableGroupings {
                columnName
                groupingOrder
                isPinned
                isCollapsed
            }
            isTableView
            userId
            lastUpdated
        }
    }
`
